require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./resources-download-emergency-back-pain-toolkit.json") })
        }
      }, "path---resources-download-emergency-back-pain-toolkit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---resources-download-emergency-back-pain-toolkit!./.cache/json/resources-download-emergency-back-pain-toolkit.json
// module id = 324
// module chunks = 231608221292675